module.exports = __webpack_public_path__ + "static/media/arrow_drop_down_black_24dp.43918ddc.svg";